<template>
  <GradientScroll
    direction="horizontal"
    class="flex flex-row w-full max-w-full"
    gradientStartColor="rgba(240, 240, 240, 0)"
    gradientEndColor="rgba(240, 240, 240, 1)"
    :gradientSize="125"
    :showScrollbar="false"
  >
    <div class="flex flex-row py-2">
      <div v-for="video in videos" :key="video.id" class="mr-3 lg:mr-6 last:mr-0">
        <AthleteVideoCard :video="video" />
      </div>
    </div>
  </GradientScroll>
</template>

<script>
import AthleteVideoCard from "./VideoCard.vue";
import GradientScroll from "@/components/GradientScroll";

export default {
  components: {
    AthleteVideoCard,
    GradientScroll
  },

  props: {
    videos: { type: Array, required: true }
  }
};
</script>
